import { createStore } from 'vuex'
import JWT from '@/store/modules/user/JWT'
import user from '@/store/modules/user'
import countHousesOnPage from '@/store/modules/user/countHousesOnPage'
import messages from '@/store/modules/messages'
import house from '@/store/modules/house'
import elements from '@/store/modules/elements'
import housesList from '@/store/modules/house/housesList'
import report from '@/store/modules/report'
import localStoragePlugin from '@/store/plugins/localStoragePlugin'
import warmUpCache from '@/store/mutations/hydrate'

export default createStore({
  strict: process.env.NODE_ENV === 'development',
  state: {
    isAuthorized: false
  },

  modules: {
    JWT,
    user,
    messages,
    house,
    elements,
    housesList,
    report,
    countHousesOnPage
  },
  mutations: {
    warmUpCache,
    setAuthorized(state, payload) {
      state.isAuthorized = payload
    }
  },
  plugins: [
    localStoragePlugin(['JWT', 'countHousesOnPage'])
  ]
})
